import { Fragment } from 'react';
import { View } from 'foundations-components/components/View';
import { getIsPropertyInput } from '../utils/getInputFieldType';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderDependents = (dependents, path, passthroughProps, enableDependentAssociations, renderInput) => {
  if (!dependents) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: dependents.map(dependent => {
      const isPropertyInput = getIsPropertyInput(dependent);
      const name = isPropertyInput ? dependent.property.name : dependent.fieldName;
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          "data-test-id": `${path}-${name}`,
          children: isPropertyInput ? renderInput ? renderInput(dependent) : dependent.render(passthroughProps) : dependent.render()
        }), renderDependents(dependent.dependents, `${path}-${name}`, passthroughProps, enableDependentAssociations, renderInput)]
      }, `${path}-${name}`);
    })
  });
};
const ConditionalPropertiesPanelDependentSection = ({
  input,
  passthroughProps,
  renderInput,
  enableDependentAssociations = false
}) => {
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": `${input.property.name}-dependents`,
    borderStyle: "solid",
    borderWidth: "100",
    borderColor: "border-core-subtle",
    borderInlineStartColor: "border-interactive-default",
    borderInlineStartWidth: "300",
    position: "relative",
    borderRadius: "100",
    marginBlockStart: "400",
    marginBlockEnd: "200",
    padding: "400",
    paddingBlockStart: "200",
    children: renderDependents(input.dependents, input.property.name, passthroughProps, enableDependentAssociations, renderInput)
  });
};
export default ConditionalPropertiesPanelDependentSection;